/** Minimum viewport width at which the P&I grid freezes its full three-column region. */
export const PI_GRID_FROZEN_COLUMN_BREAKPOINT = '1280px';

/** Leading columns frozen at or above PI_GRID_FROZEN_COLUMN_BREAKPOINT: select, Lender, Payment. */
export const PI_GRID_FROZEN_COLUMN_COUNT = 3;

/** Leading columns frozen below it: select plus the merged Lender/Payment cell. */
export const PI_GRID_COMPACT_FROZEN_COLUMN_COUNT = 2;
